import mastercard from '../images/mastercard.svg'
import visa from '../images/visa.svg'
import hipercard from '../images/hipercard.svg'
import elo from '../images/elo.svg'

export default {
  mastercard,
  visa,
  hipercard,
  elo,
}



// WEBPACK FOOTER //
// ./components/BrandLogo/helpers/brandLogos.js